import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { BryxDataGrid } from "../BryxDataGrid";
import BryxDataGridFooter from "../BryxDataGrid/BryxDataGridFooter";
import BryxChooseTableReportBuilderToolbar from "./BryxChooseTableReportBuilderToolbar";
export const BryxChooseTable = styled((props) => {
    const { toolbarItems, ...other } = props;
    return (_jsx(BryxDataGrid, { ...other, autoHeight: false, marginX: 24, disableDragIcon: true, components: {
            Footer: BryxDataGridFooter,
            Toolbar: BryxChooseTableReportBuilderToolbar,
        }, componentsProps: {
            toolbar: {
                toolbarItems: toolbarItems,
            },
        }, getRowHeight: () => "auto", checkboxSelection: false, disableMultipleSelection: true, disableColumnMenu: true, disableColumnReorder: true, disableColumnSelector: true, disableChildrenSorting: true, disableSelectionOnClick: false }));
})(({ theme }) => ({}));
export default BryxChooseTable;
